import type { TopSellersFilterState } from "../types";

export function getDefaultFilterState(): TopSellersFilterState {
  return {
    genres: null,
    categories: null,
    tags: null,
    languages: null,
    priceFrom: null,
    priceTo: null,
    ratingFrom: null,
    ratingTo: null,
    discountFrom: null,
    discountTo: null,
    releaseFrom: null,
    releaseTo: null,
    upcomingOnly: false,
    contentDescriptorIds: null,
    appTypes: null,
    reviewsFrom: null,
    reviewsTo: null,
    followersFrom: null,
    followersTo: null,
    ccuFrom: null,
    ccuTo: null,
    peakCcuFrom: null,
    peakCcuTo: null,
    publishers: null,
    developers: null,
    os: null,
    releaseStatus: null,
    eaExitFrom: null,
    eaExitTo: null,
    achievementsFrom: null,
    achievementsTo: null,
    wishlistRankFrom: null,
    wishlistRankTo: null,
  };
}

export function hasActiveFilters(state: TopSellersFilterState): boolean {
  return hasActiveFiltersExcept(state, []);
}

export function countActiveFilters(state: TopSellersFilterState): number {
  return countActiveFiltersExcept(state, []);
}

/** Підрахунок активних фільтрів, ігноруючи вказані поля (напр. releaseFrom, upcomingOnly для monthly) */
export function countActiveFiltersExcept(
  state: TopSellersFilterState,
  ignore: (keyof TopSellersFilterState)[]
): number {
  let count = 0;
  if (!ignore.includes("genres")) count += state.genres?.length ?? 0;
  if (!ignore.includes("categories")) count += state.categories?.length ?? 0;
  if (!ignore.includes("tags")) count += state.tags?.length ?? 0;
  if (!ignore.includes("languages")) count += state.languages?.length ?? 0;
  if (!ignore.includes("priceFrom") && state.priceFrom != null) count++;
  if (!ignore.includes("priceTo") && state.priceTo != null) count++;
  if (!ignore.includes("ratingFrom") && state.ratingFrom != null) count++;
  if (!ignore.includes("ratingTo") && state.ratingTo != null) count++;
  if (!ignore.includes("discountFrom") && state.discountFrom != null) count++;
  if (!ignore.includes("discountTo") && state.discountTo != null) count++;
  if (!ignore.includes("releaseFrom") && state.releaseFrom != null) count++;
  if (!ignore.includes("releaseTo") && state.releaseTo != null) count++;
  if (!ignore.includes("upcomingOnly") && state.upcomingOnly) count++;
  if (!ignore.includes("contentDescriptorIds"))
    count += state.contentDescriptorIds?.length ?? 0;
  if (!ignore.includes("appTypes")) count += state.appTypes?.length ?? 0;
  if (!ignore.includes("reviewsFrom") && state.reviewsFrom != null) count++;
  if (!ignore.includes("reviewsTo") && state.reviewsTo != null) count++;
  if (!ignore.includes("followersFrom") && state.followersFrom != null) count++;
  if (!ignore.includes("followersTo") && state.followersTo != null) count++;
  if (!ignore.includes("ccuFrom") && state.ccuFrom != null) count++;
  if (!ignore.includes("ccuTo") && state.ccuTo != null) count++;
  if (!ignore.includes("peakCcuFrom") && state.peakCcuFrom != null) count++;
  if (!ignore.includes("peakCcuTo") && state.peakCcuTo != null) count++;
  if (!ignore.includes("publishers")) count += state.publishers?.length ?? 0;
  if (!ignore.includes("developers")) count += state.developers?.length ?? 0;
  if (!ignore.includes("os")) count += state.os?.length ?? 0;
  if (!ignore.includes("releaseStatus") && state.releaseStatus != null) count++;
  if (!ignore.includes("eaExitFrom") && state.eaExitFrom != null) count++;
  if (!ignore.includes("eaExitTo") && state.eaExitTo != null) count++;
  if (!ignore.includes("achievementsFrom") && state.achievementsFrom != null) count++;
  if (!ignore.includes("achievementsTo") && state.achievementsTo != null) count++;
  if (!ignore.includes("wishlistRankFrom") && state.wishlistRankFrom != null) count++;
  if (!ignore.includes("wishlistRankTo") && state.wishlistRankTo != null) count++;
  return count;
}

export function hasActiveFiltersExcept(
  state: TopSellersFilterState,
  ignore: (keyof TopSellersFilterState)[]
): boolean {
  return countActiveFiltersExcept(state, ignore) > 0;
}

/**
 * Перемикає елемент у масиві
 * Повертає null якщо масив порожній (за специфікацією)
 */
export function toggleInArray<T>(list: T[] | null, item: T): T[] | null {
  const set = new Set(list ?? []);
  if (set.has(item)) set.delete(item);
  else set.add(item);
  const arr = Array.from(set);
  return arr.length ? arr : null;
}
